(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';

        // Page orientation variable
        var mql = window.matchMedia("(orientation: portrait)"); //test

        // SDrive Variables
        var documentPath = window.location.pathname;
        var pageName = document.title;
        var pageLayout = getPageLayout(); // Breakpoints of wireframe widths
        var pageOrientation = getOrientation(mql);
        var dealerID = skodaVariables.dealerID;
        var importerBID = skodaVariables.importerID;
        var productsCount = skodaVariables.productsCount;
        var pageContext = 'Dealer';
        var pageSection = getPageSection();
        var pageGroup = 'Dealer Page';
        var currency = LhApp.Context.Currency.Code;
        var $promotionElements = $('[data-promotion="true"]');
        var $formElements = $('[data-form="true"]');
        var $formFields = $('[data-field-name]', $formElements);
        var languageVersion = (LhApp.Context.Language + '-' + LhApp.Context.Country).toLowerCase();        
        var webEnvironment = skodaVariables.getWebEnv();
        
        function Init() {
            window.dataLayer = window.dataLayer || [];

            if (skodaVariables.ctaTypes === undefined && window !== window.top) // Used cars pop up fix cta types
                skodaVariables.ctaTypes = window.top.skodaVariables.ctaTypes;
                        
            // Global events trigger
            window.lhSdriveTracking = {
                pageViewData: {},
                sendPageview: function () {
                    delete this.pageViewData['gtm.uniqueEventId'];
                    dataLayer.push(this.pageViewData);
                },
                vpData: {},
                sendVirtualPageview: function () {
                    delete this.vpData['gtm.uniqueEventId'];
                    dataLayer.push(this.vpData);
                },
                sendPreviousView: function() {
                    (newsDetailsPage() || usedCarsPageWithFilters()) ? this.sendVirtualPageview() 
                    : this.sendPageview();
                },
                searchData: {},
                sendSearchClick: function (queries, results) {
                    this.searchData.search_queries = queries;
                    this.searchData.search_results = results;
                    dataLayer.push(this.searchData);
                }
            };            

            // Track pageView
            if (!(carDetailsPopup() || newsDetailsPage() || usedCarsPageWithFilters())) { // all but car details popup, news details page or used cars page with filters

                var carInView = $('[data-car-model]');                
                var carModel = carInView.attr('data-car-model');
                var carBody = carInView.attr('data-car-body');
                var carLine = carInView.attr('data-car-line');
                var carSalesGroup = carInView.attr('data-car-sales-group');
                var carDetailViews = (carInView.length > 0) ? 1 : null;

                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_section': pageSection,
                    'page_group': pageGroup,
                    'page_name': pageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': pageLayout,
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1',
                    'car_model': carModel,
                    'car_model_body': carBody,
                    'car_carline': carLine,
                    'car_salesgroup': carSalesGroup,
                    'car_detail_views': carDetailViews
                })
                                
                dataLayer.push(dataToPush);
                window.lhSdriveTracking.pageViewData = dataToPush;
            }

            // Track virtual pageview (used cars page)
            if (usedCarsPageWithFilters()) {
                
                var filters = LhApp.Function.QueryString.parse(window.location.search);      

                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',
                    'filter_model': filters.brand,
                    'filter_sorting': filters.sort,
                    'filter_dealers': filters.branches,
                    'filter_budget_from': filters['price-from'],
                    'filter_budget_to': filters['price-to'],
                    'filter_results': productsCount,
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_section': pageSection,
                    'page_group': pageGroup,
                    'page_name': pageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': pageLayout,
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1',
                });

                dataLayer.push(dataToPush);
                window.lhSdriveTracking.vpData = dataToPush;
            }

            // Track virtual pageview (used car details popup)
            if (carDetailsPopup()) {

                var $thisCar = $('[data-car-model]');
                var carModel = $thisCar.attr('data-car-model');
                var carBody = $thisCar.attr('data-car-body');
                var carLine = $thisCar.attr('data-car-line');
                var carPrice = $thisCar.attr('data-price');
                var carSalesGroup = $thisCar.attr('data-car-sales-group');
                var topWindow = (window !== window.top);

                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',
                    'car_model': carModel,
                    'car_model_body': carBody,
                    'car_carline': carLine,
                    'car_price': carPrice,
                    'currency': currency,
                    'car_salesgroup': carSalesGroup,
                    'car_detail_views': 1,
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_section': pageSection,
                    'page_group': pageGroup,
                    'page_name': pageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': getPageLayout(topWindow),
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1', 
                });

                dataLayer.push(dataToPush);
                window.lhSdriveTracking.vpData = dataToPush;
            }

            // Track virtual pageview (news details)
            if (newsDetailsPage()) {
                
                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',                    
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_section': pageSection,
                    'page_group': pageGroup,
                    'page_name': pageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': pageLayout,
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1', 
                });

                dataLayer.push(dataToPush);
                window.lhSdriveTracking.vpData = dataToPush;
            }

            // Track virtual pageview home dealers list (store locator)
            $('.js-info-toggle-btn', '[data-dealerid]').click(function () {
                
                if($(this).hasClass('icon-Up4')) return; // Already opened dont track

                var $thisParent = $(this).parents('[data-dealerid]');
                //var thisDealerID = $thisParent.attr('data-dealerid'); // Meeting change
                //var thisImporterID = thisDealerID.split('-')[0]; 
                var thisPageName = $thisParent.attr('data-dealername');

                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_group': pageGroup,
                    'page_name': thisPageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': pageLayout,
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1',
                });

                dataLayer.push(dataToPush);
            });
            
            // Track virtual pageview contact page dealers slider
            $('[data-dealerid]', '.store-locator-page').click(function () {
                
                if($(this).hasClass('selected')) return; // Already selected dont track
                
                //var thisDealerID = $(this).attr('data-dealerid'); // Meeting change
                //var thisImporterID = thisDealerID.split('-')[0];
                var thisPageName = $(this).attr('data-dealername');

                var dataToPush = noEmptyProps({
                    'event': 'pageView',
                    'event_name': 'page_view',
                    'document_path': documentPath,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_group': pageGroup,
                    'page_name': thisPageName,
                    'page_language_version': languageVersion,
                    'page_context': pageContext,
                    'page_responsive_layout': pageLayout,
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '1', 
                });

                dataLayer.push(dataToPush);
            });

            // Track stock cars CTA button show all
            $('.react-container').on('click', '.btn-show-all', function(evt) {
                var $this = $(evt.currentTarget);
                var href = $this.prop('href') || null;
                var hitClickURL = (href && href.indexOf('?') > -1) ? href.split('?')[0] : href;

                var dataToPush = noEmptyProps({
                    'event': 'trackEvent',
                    'event_name': 'cta_click',
                    'event_category': 'CTA',
                    'event_action': 'Stock cars click',
                    'event_label': 'Show all',
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'cta_type': 'Stock cars',
                    'hit_click_url': hitClickURL,
                    'web_environment': webEnvironment,
                    'matrix_id': '17', // Matrix Id for cta click
                });

                dataLayer.push(dataToPush);
            });

            // Track contact page dealers more info btn
            $('.go-to-more').on('click', function () {
                var buttonText = $(this).text();

                var dataToPush = noEmptyProps({
                    'event': 'trackEvent',
                    'event_name': 'button_click',
                    'event_category': 'Dealer Page',
                    'event_action': 'Button Click',
                    'event_label': buttonText,
                    'importer_bid': importerBID,
                    'dealer_id': dealerID,
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'web_environment': webEnvironment,
                    'matrix_id': '5', // Matrix Id for button click
                });

                dataLayer.push(dataToPush);
            });

            // Track layout change
            $(window).on('resize', function () {
                pageLayout = getPageLayout();
            });

            // Track orientation change
            mql.addListener(function (m) {
                pageOrientation = (m.matches) ? 'Portrait' : 'Landscape';

                dataLayer.push({
                    'event': 'trackEvent',
                    'event_name': 'orientation_change',
                    'event_category': 'Dealer Page',
                    'event_action': 'Orientation change',
                    'event_label': pageOrientation,
                    'event_non_interaction': 'true',
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'page_responsive_layout': getPageLayout(),
                    'page_orientation': pageOrientation,
                    'web_environment': webEnvironment,
                    'matrix_id': '6', // Matrix Id for orientation change
                });
            });

            // Track view_promotion
            if ($promotionElements.length > 0) {

                function checkViewablePromos() {

                    $promotionElements.each(function () {

                        if (!($(this).is(':visible'))) return;

                        if (isElementInViewport($(this))) { // Check if this promotion is in view port
                          
                            var promotionName = $(this).attr('data-promotion-name');                            
                            var promoPositionArr = $(this).attr('data-promotion-position').split('-');
                            promoPositionArr[2] = Number(promoPositionArr[2]) + 1;
                            var promotionPosition = promoPositionArr.join('-');
                            var promotionId = undefined;

                            if (trackedPromo.indexOf(promotionPosition) >= 0) return; // This promo is already tracked

                            if (promotionName === '') {
                                promotionName = undefined;
                            }

                            if (promotionName) {
                                promotionId = promotionName.replaceAll(' ', '_');
                            }
                            
                            var dataToPush = noEmptyProps({
                                'event': 'trackEcEvent',
                                'event_name': 'view_promotion',
                                'event_category': 'Promotion',
                                'event_action': promotionName,
                                'event_label': 'Promotion view',
                                'event_non_interaction': 'true',
                                'ecommerce': {
                                    'items': [
                                        {
                                            "promotion_id": promotionId,
                                            "promotion_name": promotionName,
                                            "creative_slot": promotionPosition,
                                        }
                                    ]
                                },
                                'page_group': pageGroup,
                                'page_context': pageContext,
                                'web_environment': webEnvironment,
                                'matrix_id': '2', // Matrix Id for promotion view                               
                            });

                            dataLayer.push(dataToPush);

                            trackedPromo.push(promotionPosition); // Add to tracked list
                        }
                        
                    });

                }

                var trackedPromo = []; // Save tracked promotions

                checkViewablePromos(); // Runs on page load

                $(window).scroll($.debounce(300, checkViewablePromos)); // Runs when user scrolls
            }
            
            // Track promotion_click
            $promotionElements.click('a', function (evt) { 

                if (!($(evt.target).is('a') || $(evt.target).parents('a').length >= 1)) return; // Not anchor link

                if ($(evt.target).attr('data-redirect') === "false" || $(evt.target).parents('a').attr('data-redirect') === "false") return console.log('not redirect'); // Not anchor link
                
                var redirectLink = $(this).find('a').prop('href');
                var target = $(this).find('a').prop('target') || "_self";
                if (!redirectLink) return console.warn('Promotion click event: redirectLink not found');
                
                evt.preventDefault();
                evt.stopImmediatePropagation(); // Prevent redirect from child a element

                var promotionName = $(this).attr('data-promotion-name');          
                var promoPositionArr = $(this).attr('data-promotion-position').split('-');
                promoPositionArr[2] = Number(promoPositionArr[2]) + 1;
                var promotionPosition = promoPositionArr.join('-');
                var promotionId = undefined;
                
                if (promotionName) {
                    promotionId = promotionName.replaceAll(' ', '_');
                }
                var redirect = false;

                var dataToPush = noEmptyProps({
                    'event': 'trackEcEvent',
                    'event_name': 'select_promotion',
                    'event_category': 'Promotion',
                    'event_action': promotionName,
                    'event_label': 'Promotion click',
                    'ecommerce': {
                        'items': [
                            {
                                "promotion_id": promotionId,
                                "promotion_name": promotionName,
                                "creative_slot": promotionPosition,
                            }
                        ]
                    },
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'web_environment': webEnvironment,
                    'matrix_id': '3', // Matrix Id for promotion click
                    'eventCallback': function () {
                        if (redirect) return;
                        redirect = true;
                        if (target === "_blank") {
                            window.open(redirectLink);
                        } else {
                            window.location = redirectLink;
                        }
                    }
                });

                dataLayer.push(dataToPush);

                setTimeout(function () { // Redirect in any case after 500ms
                    if (redirect) return;
                    redirect = true;
                    if (target === "_blank") {
                        window.open(redirectLink);
                    } else {
                        window.location = redirectLink;
                    }
                }, 500);

            })
            
            // Track cta and button click
            function trackClick(evt) {
                                
                var $this = $(evt.currentTarget);
                var linkDataSrc = $this.attr('data-src');
                var fancyLinks = ['#test-drive', '#book-service', '#call-back', '#quote-form'];
                if (fancyLinks.indexOf(linkDataSrc) > -1) {
                    return; // Dont track data fancybox links
                }

                var buttonText = $this.text().replace(/\s+/g, ' ').trim();
                var href = $this.prop('href') || null;
                var hitClickURL = (href && href.indexOf('?') > -1) ? href.split('?')[0] : href;
                var dataLinkCode = $this.attr('data-link-code');

                if (dataLinkCode === 'download_pricelist' || dataLinkCode === 'download_brochure') { // Download   
                    var $thisCar = $this.parents('[data-car-model]');
                    var carModel = $thisCar.attr('data-car-model');
                    var carModelBody = $thisCar.attr('data-car-body');
                    var carLine = $thisCar.attr('data-car-line');
                    var carSalesGroup = $thisCar.attr('data-car-sales-group');
                    var docTypes = {
                        'download_pricelist': 'Pricelist',
                        'download_brochure': 'Brochure'
                    }
                    var documentType = docTypes[dataLinkCode];

                    var dataToPush = noEmptyProps({
                        'event': 'trackEvent',
                        'event_name': 'download',
                        'event_category': 'Dealer Page',
                        'event_action': 'Download',
                        'event_label': hitClickURL,
                        'document_type': documentType,
                        'page_group': pageGroup,
                        'page_context': pageContext,
                        'web_environment': webEnvironment,
                        'matrix_id': '8', // Matrix Id for download
                        'car_model': carModel,
                        'car_model_body': carModelBody,
                        'car_carline': carLine,
                        'car_salesgroup': carSalesGroup
                    });

                    dataLayer.push(dataToPush);
                    return; 
                }

                var secondBtn = $this.data('second-btn');
                var thirdBtn = $this.data('third-btn');

                if (secondBtn === 'vcfg_glb_financingcalculator' || thirdBtn === 'vcfg_glb_financingcalculator')
                    dataLinkCode = 'vcfg_glb_financingcalculator';

                var ctaType = (dataLinkCode !== undefined) ? getCtaType(dataLinkCode) : undefined;

                if ($this.hasClass('ck-form-action')) {
                    if ($this.hasClass('ck-book-service')) {
                        ctaType = "Book a service";
                    } else if ($this.hasClass('ck-contact')) {
                        ctaType = "Contact dealer";
                    } else if ($this.hasClass('ck-test-drive')) {
                        ctaType = "Test drive";
                    } else if ($this.hasClass('ck-request-quote')) {
                        ctaType = "Get a quote";
                    }
                }

                if (ctaType === undefined) { // Simple button click
                    var dataToPush = noEmptyProps({
                        'event': 'trackEvent',
                        'event_name': 'button_click',
                        'event_category': 'Dealer Page',
                        'event_action': 'Button Click',
                        'event_label': buttonText,
                        'hit_click_url': hitClickURL,
                        'importer_bid': importerBID,
                        'dealer_id': dealerID,
                        'page_group': pageGroup,
                        'page_context': pageContext,
                        'web_environment': webEnvironment,
                        'matrix_id': '5', // Matrix Id for button click
                    });

                    dataLayer.push(dataToPush);

                } else { // CTA
                    if (
                        ctaType === 'Facebook' ||
                        ctaType === 'Instagram' ||
                        ctaType === 'Twitter' ||
                        ctaType === 'Youtube'
                    ) {
                        buttonText = ctaType;
                    }

                    var dataToPush = noEmptyProps({
                        'event': 'trackEvent',
                        'event_name': 'cta_click',
                        'event_category': 'CTA',
                        'event_action': 'Dealer Page',
                        'event_label': buttonText,
                        'page_group': pageGroup,
                        'page_context': pageContext,
                        'cta_type': ctaType,
                        'hit_click_url': hitClickURL,
                        'web_environment': webEnvironment,
                        'matrix_id': '17', // Matrix Id for cta click
                    });

                    dataLayer.push(dataToPush);
                }
            }
                        
            $('a').on('click', trackClick);
            $('a').middleClick(trackClick);
            $('.x-google-map').on('click', 'a', trackClick);

            if (skodaVariables.template === 'SearchProducts') // Async binding of 'a' click on search results page
                window.lhSdriveTracking.trackClick = trackClick;

            // Track search
            if ($('[data-search="true"]').length > 0) {

                var dataToPush = noEmptyProps({
                    'event': 'trackEvent',
                    'event_name': 'search_click',
                    'event_category': 'Dealer Page',
                    'event_action': 'Search',
                    'event_label': 'Search',
                    'page_group': pageGroup,
                    'page_context': pageContext,                   
                    'web_environment': webEnvironment,
                    'matrix_id': '27', // Matrix Id for search                    
                });

                window.lhSdriveTracking.searchData = dataToPush;
            }

            // Track search suggestions
            $('.x-searchbox').on('click', 'a', function () {
                var $suggestList = $(this).parents('.suggestion-list');
                var $suggestions = $('li', $suggestList);
                var searchText = $suggestions.first().data('suggestion');
                var suggestionsCount = $suggestions.length - 1;

                var dataToPush = noEmptyProps({
                    'event': 'trackEvent',
                    'event_name': 'search_click',
                    'event_category': 'Dealer Page',
                    'event_action': 'Search',
                    'event_label': 'Search',
                    'search_queries': searchText,
                    'search_results': suggestionsCount.toString(),
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'web_environment': webEnvironment,                    
                    'matrix_id': '27', // Matrix Id for search                    
                });

                dataLayer.push(dataToPush);
            });

            // Form checkViewable definition
            var forms = {};
            forms.checkViewable = function () {

                $formElements.each(function () {
                    
                    if (!($(this).is(':visible'))) return;

                    if (isElementInViewport($(this))) { // Check if this form is in view port

                        var formCode = $(this).attr('data-form-code');
                        var formType = $(this).attr('data-form-type');

                        dataLayer.push({
                            'event': 'trackEvent',
                            'event_name': 'form_start',
                            'page_group': pageGroup,
                            'page_context': pageContext,
                            'form_type': formType,
                            'form_code': formCode,
                            'web_environment': webEnvironment,
                            'matrix_id': '53', // Matrix Id for form start
                        })

                        
                        dataLayer.push({
                            'event': 'pageView',
                            'event_name': 'virtual_pageview',                            
                            'document_path': documentPath,
                            'importer_bid': importerBID,
                            'dealer_id': dealerID,
                            'page_group': pageGroup,
                            'page_name': formType,
                            'page_language_version': languageVersion,
                            'page_context': pageContext,
                            'page_responsive_layout': pageLayout,
                            'page_orientation': pageOrientation,
                            'web_environment': webEnvironment,
                            'matrix_id': '1', // Matrix Id for virtual pageview
                        });
                    }

                });

            }

            // Track form start
            if ($formElements.length > 0) {
                                
                forms.checkViewable(); // Runs on page load

                $(window).scroll($.debounce(300, forms.checkViewable)); // Runs when user scrolls

                var popupForms = [
                    '.order-test-drive-popup',
                    '.book-service-form-popup',
                    '.call-back-form-popup',
                    '.quote-form-popup'
                ];

                popupForms.forEach(function (popupForm) { // Runs when popupForms go visible
                    $(popupForm).changed(function () {
                        setTimeout(forms.checkViewable, 500);
                    });
                });

            }

            // Track form focus
            $formFields.focus(function () {

                var fieldName = $(this).attr('data-field-name');
                var $form = $(this).parents('[data-form="true"]');
                var formType = $form.attr('data-form-type');
                var formCode = $form.attr('data-form-code');

                dataLayer.push({
                    'event': 'trackEvent',
                    'event_name': 'form_focus',
                    'event_label': fieldName,
                    'form_type': formType,
                    'form_code': formCode,
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'web_environment': webEnvironment,
                    'matrix_id': '25', // Matrix Id for form focus
                });
                                                                
            });

            // Track form skip
            $formFields.focusout(function () {

                var fieldValue = $(this).val();

                if (fieldValue) return; // Do not send skip event

                var fieldName = $(this).attr('data-field-name');
                var $form = $(this).parents('[data-form="true"]');
                var formType = $form.attr('data-form-type');
                var formCode = $form.attr('data-form-code');

                dataLayer.push({
                    'event': 'trackEvent',
                    'event_name': 'form_skip',
                    'event_label': fieldName,
                    'form_type': formType,
                    'form_code': formCode,
                    'page_group': pageGroup,
                    'page_context': pageContext,
                    'web_environment': webEnvironment,
                    'matrix_id': '57', // Matrix Id for form skip
                });

            });

            // Track form close - send new pageview event
            $("[data-fancybox]").fancybox({
                afterClose: function () {
                    window.lhSdriveTracking.sendPreviousView();                  
                }
            });

            // Track scroll depth
            $(window).on('load', function () {
                var windowHeight; // Init height of window
                var thresholds = [
                    { 'percent': '25' },
                    { 'percent': '50' },
                    { 'percent': '75' },
                    { 'percent': '100' },
                ];

                var calcThresholds = function () {
                    windowHeight = window.innerHeight; // Set height of window
                    var pageHeight = window.document.documentElement.scrollHeight; // Set height of page
                    thresholds.forEach(function (threshold) { // Set height of each threshold
                        threshold.height = (percentage(pageHeight, parseInt(threshold.percent)) - 10); // Remove 10 pixel for cushion iphone fix                        
                    });
                }

                calcThresholds(); // Calculate thresholds based on page height

                var checkDepth = $.debounce(300, function () {
                    var depth = window.pageYOffset + windowHeight; // Get current scroll depth
                    thresholds.forEach(function (threshold) {
                        if (depth > threshold.height) { // Fire event if any threshold passed
                            threshold.passed = true;

                            dataLayer.push({
                                'event': 'trackEvent',
                                'event_name': 'scroll_down',
                                'event_action': 'Scroll down',
                                'event_label': 'Scroll depth: ' + threshold.percent + '%',
                                'event_category': 'Dealer Page',
                                'page_group': pageGroup,
                                'page_context': pageContext,
                                'page_scroll_depth': threshold.percent + '%',
                                'web_environment': webEnvironment,
                                'matrix_id': '4', // Matrix Id for scroll depth
                            });
                        }
                    });
                    thresholds = thresholds.filter(function (threshold) { return !threshold.passed }) // Remove passed thresholds from array of thresholds
                    if (thresholds.length === 0) $(window).off('scroll', checkDepth); // Remove event listener of no threshold is remaining
                });

                checkDepth(); // Fires on page load
                $(window).on('scroll', checkDepth); // Fires on scroll 
                $(window).on('resize', $.debounce(300,calcThresholds)); // Fires on resize
            });
                       
        }

        // jQuery EL Change
        (function ($) {
            $.fn.changed = function (cb, e) {
                e = e || { subtree: true, childList: true, characterData: true };
                $(this).each(function () {
                    function callback(changes) { cb.call(node, changes, this); }
                    var node = this;
                    (new MutationObserver(callback)).observe(node, e);
                });
            };
        })(jQuery);

        // jQuery middleClick
        (function ($) {
            $.fn.middleClick = function (cb) {
                $(this).on("mousedown", function (e1) {
                    $(this).on("mouseup", function (e2) {
                        if (e1.which == 2 && e1.target == e2.target) {
                            cb.call(this);
                        }
                    });
                });
            };
        })(jQuery);

        // Page Layout
        function getPageLayout(topWindow) {
            var deviceMinWidths = {
                'LargeDesktop': 1200,
                'Desktop': 922,
                'Tablet': 576,
                'Mobile': 0
            }
            var width = (topWindow) ? window.top.innerWidth : window.innerWidth;
            for (var device in deviceMinWidths) {
                if (width >= deviceMinWidths[device]) {
                    return device;
                }
            }
        }

        // Get Page Orientation        
        function getOrientation(mql) { 
            return (mql.matches) ? 'Portrait' : 'Landscape'; 
        }

        // Get Page Section
        function getPageSection() {
            var pageTemplate = skodaVariables.template;

            var pagesWithStockCars = ['ProductDetails_B', 'ProductList_StockCars'];
            if (pagesWithStockCars.indexOf(pageTemplate) > -1) return 'Stock cars';

            var pagesWithUsedCars = ['ProductList', 'ProductDetailsPopUp'];
            if (pagesWithUsedCars.indexOf(pageTemplate) > -1) return 'Used Cars';

            return '';
        }

        // Get cta type from data-code        
        function getCtaType(code) {            
            return skodaVariables.ctaTypes[code];
        }

        // Check Page Template - Used Cars
        function usedCarsPage() {
            return (skodaVariables.template === "ProductList");
        }

        // Check Page Template - Car Details Popup
        function carDetailsPopup() {
            return (skodaVariables.template === "ProductDetailsPopUp");
        }

        // Check Page Template - News Details
        function newsDetailsPage() {
            return (skodaVariables.template === "NewsDetails");
        }

        // Check if page url has query parameters
        function hasQueryParams() {
            var qparams = LhApp.Function.QueryString.parse(window.location.search);
            return (JSON.stringify(qparams) !== '{}');
        }

        // Check if Used Cars page has filters
        function usedCarsPageWithFilters() {
            return usedCarsPage() && hasQueryParams();
        }

        // Clean object from empty properties
        function noEmptyProps(obj) {
            for (var prop in obj) {
                if (
                    obj[prop] === ''        ||
                    obj[prop] === null      ||
                    obj[prop] === undefined ||
                    obj[prop] === 'javascript:void(0)'
                ) {
                    delete obj[prop];
                }
            }
            return obj;
        }

        // Calculate percentage
        function percentage(num, per) {
            return (num / 100) * per;
        }

        Init(); // Call init function after declaring variables and functions
    });
})();